import InviteUserFormContainer from './invite-user-form-container';

export default InviteUserFormContainer;
